let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lfrNk")).then(() => parcelRequire('dFPRW'));